import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadAnalyticItems = async () => {
  let response = await Axois.get('/analytic-items').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadAnalyticItem = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/analytic-items');
        const responseData = await requests.data;
        return {...responseData, analyticItem: {}};
        // return { analytics: [], journals: [], accounts: [], analyticItem: {}};
      
      default:
        let response = await Axois.get('/analytic-items/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { analytics: [], journals: [], accounts: [], analyticItem: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const useAnalyticItemAPI = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/analytic-items', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_item_response', responseData.number);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/analytic-items/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_item_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useAnalyticItemAPI;